<template>
  <div
    v-if="floorData"
    :class="[prefix, `${prefix}-wrap`, 'full-box']"
  >
    <div class="category-floor-container">
      <div class="category-container">
        <div
          class="left-box"
          :style="{background: `url('${floorData.PictureUrl}') no-repeat`}"
        >
          <div class="top-content">
            <h2
              class="title"
              :style="{color: floorData.ThemeColor}"
            >{{floorData.Name}}</h2>
            <div class="item-tags">
              <Tag
                v-for="(item, index) in floorData.SubCategories"
                :key="floorId + item.Id + index"
                type="border"
                :style="{borderColor: floorData.ThemeColor,background:backgroundColor}"
                color="green"
              >
                <span
                  @mouseover="onSubCategorySelected(index)"
                  :style="{color: floorData.ThemeColor}"
                  @click="selectItem(item.Id)"
                >{{item.Name}}</span>
              </Tag>
            </div>
            <div class="view-all">
              <Button
                type="text"
                ghost
              >
                <span
                  class="all"
                  @click="viewAll(floorData.Category.Id)"
                >查看全部</span><span class="icon iconfont icongengduo"></span>
              </Button>
            </div>
          </div>
        </div>
        <div class="right-box">
          <div class="flex">
            <div
              class="item"
              v-for="(item, index) in topProducts"
              :key="item.Id + index"
            >
              <SimpleProductItem
                :product="item"
                :class="{large: topProducts.length < 3}"
              ></SimpleProductItem>
            </div>
          </div>
          <div class="flex">
            <div
              class="item"
              v-for="(item, index) in bottomProducts"
              :key="item.Id + index"
            >
              <SimpleProductItem
                :product="item"
                class="large"
              ></SimpleProductItem>
            </div>
          </div>
        </div>
      </div>
      <div class="brand-container">
        <div class="brand-box">
          <div
            class="brand-item"
            v-for="(item, index) in manufacturers"
            :key="index"
            :title="item.Name"
            @click="toProductList(item.Id)"
          >
            <div v-if="item.Id">
              <img :src="item.Picture">
              <p>{{item.Name}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import '@/styles/components/category/categoryFloor.scss';
import SimpleProductItem from '@/components/product/SimpleProductItem.vue';
import helper from '@/utils/helper.js';
const prefix = 'cpt-category-floor';
export default {
  name: 'CategoryFloor',
  components: {
    SimpleProductItem
  },
  props: {
    floorData: {}
  },
  data () {
    return {
      prefix,
      floorId: helper.newGuid(),
      backgroundColor: 'rgba(0,0,0,0) !important',
      products: [],
      manufacturers: []
    };
  },
  computed: {
    topProducts () {
      let arr = this._.take(this.products, 3);
      const len = arr.length;
      const rdm = helper.newGuid();
      for (let i = 3; i > len; i--) {
        arr.push({ Id: i + rdm });
      }
      return arr;
    },
    bottomProducts () {
      let arr = this._.take(this.products, 5).slice(3, 5);
      // let arr = this._.take(this.products, (value, index) => { return index > 0; });
      const len = arr.length;
      const rdm = helper.newGuid();
      for (let i = 2; i > len; i--) {
        arr.push({ Id: i + rdm });
      }
      return arr;
    }
  },
  methods: {
    onSubCategorySelected (index) {
      const tempProducts = this.floorData.SubCategories[index].Products;
      for (var i = 0; i < tempProducts.length - 1; i++) {
        for (var j = 0; j < tempProducts.length - 1 - i; j++) {
          if (tempProducts[j].DisplayOrder > tempProducts[j + 1].DisplayOrder) {
            var temp = tempProducts[j];
            tempProducts[j] = tempProducts[j + 1];
            tempProducts[j + 1] = temp;
          }
        }
      }
      this.products = this._.take(tempProducts, 5);
    },
    hideDetail () {
      this.panelVisible = false;
    },
    viewAll (id) {
      this.$router.push({
        path: '/productList',
        query: {
          categoryId: id
        }
      });
    },
    selectItem (id) {
      this.$router.push({
        path: '/productList',
        query: {
          categoryId: id
        }
      });
    },
    toProductList (id) {
      this.$router.push({
        path: '/productList',
        query: {
          brandId: id
        }
      });
    }
  },
  created () {
    if (this.floorData && this.floorData.SubCategories.length > 0) {
      this.onSubCategorySelected(0);
    }
    if (this.floorData && this.floorData.Manufacturers.length > 0) {
      this.manufacturers = this._.take(this.floorData.Manufacturers, 7);
      for (let i = 7; i > this.floorData.Manufacturers.length; i--) {
        this.manufacturers.push({});
      }
    }
  }
};
</script>

<style lang='scss' scoped>
@import '@/styles/base.scss';
</style>



// WEBPACK FOOTER //
// src/components/category/CategoryFloor.vue